/** 缓存统一前缀，写入方*/
export const CACHE_KEY_PREFIX = 'WPHK_ACT_BASE';
/** 重定向次数记录key */
export const REDIRECT_TAG = `${CACHE_KEY_PREFIX}#SIMPLE_LOGIN_TIMES`;
/** 活动简单登录新接口 */
export const LoginSimpleApi = '/app/promotion/prom_login_simple.cgi';
/** 消费登陆token接口 */
export const CONSUME_LOGIN_TOKEN_API = '/app/promotion/prom_consume_login_token.cgi';
/** 简单登录session tag */
export const SESSION_SIMPLE_LOGIN_TAG = `${CACHE_KEY_PREFIX}#SIMPLE_LOGIN_TAG`;
/** 简单登录session tag */
export const SESSION_SIMPLE_LOGIN_VALUE = '1';
/** 微信OAuth授权地址 */
export const WX_OAUTH_URL = 'https://open.weixin.qq.com/connect/oauth2/authorize';
/** 微信授权appid */
export const WX_APPID = 'wxd82e1d3dfccffe5e';
/** 微信授权code字段 */
export const WX_OAUTH_CODE = 'code';
/** token登陆标识字段 */
export const LOGIN_TOKEN = '_stk';
/** 微信授权state */
export const WX_OAUTH_STATE = 'state';
/** 微信授权pass_ticket */
export const PASS_TICKET = 'pass_ticket';
/** 香港钱包开通页-h5场景时使用 */
export const HK_WALLET_OPEN_URL = 'https://hkwallet.moneydata.hk/cgi-bin/app/ewallet_bindcard/ewallet_auto_wallet_index.cgi';
/** 香港钱包开通引导页-小程序内嵌时使用 */
export const HK_WALLET_OPEN_URL_MP = 'https://prom.wechatpay.com.hk/mojo/prom/app_4_3759/index.shtml';
/** OAuth授权code请求失败错误码 */
export const OAUTH_CODE_ERROR_CODES = ['8598999005', '8598999003', '8598999006', '8598999004'];
/** 非香港钱包用户错误码 */
export const IS_NOT_HK_USER_CODES = ['8598999016', '8598999017', '8598999014'];
